import React, { Fragment } from 'react'
import { NavLink, Link } from 'react-router-dom'
import FooterArea from '../../../components/FooterArea'

import FileChequesIndex from '../../../components/fileCheques'
import './style.scss'
const FileChequesPages = () => {
    const [readMore, setReadMore] = React.useState(true);
    return (
        <Fragment>
            
           <FileChequesIndex
           className="SignInArea"
            />
            <FooterArea/>
        </Fragment>
    )
}
export default FileChequesPages
/* FileChequesIndex */